import  { BASE_URL_ORGANIZATION } from "../services/organizationAPI";

import { Organization, OrganizationPatch } from "../types/organization.types";
import { useParams } from "react-router-dom";
import { useAuth } from "../../auth/hooks";
import { useSingleGenericAPI } from "../../../utils/genericAPI/useGenericAPI";
import { Wallet, WalletPatch } from "../../wallet/types/wallet.types";


/**
 * useSingleOrganization
 *
 */

export const useSingleOrganization = (organizationId?: string) => {
  const { organizationId: idUrl } = useParams<{ organizationId: string }>();
  const idFound = organizationId || idUrl;

  if (!idFound) {
    console.error("useSingleOrganization: organizationId is required");
  }

  return useSingleOrganizationCore({ organizationId: idFound || "" });
};

export interface useSingleOrganizationConfig {
  organizationId: string;
}

/**
 * use Single Organization
 * @returns
 */
function useSingleOrganizationCore({
  organizationId,
}: useSingleOrganizationConfig) {
  
  const { setHeaderAuthToRequest } = useAuth();
  setHeaderAuthToRequest();

  const {singleQuery, deleteQuery,patchQuery} = useSingleGenericAPI<Organization, OrganizationPatch>({
    baseURL: BASE_URL_ORGANIZATION,
    APIname: "organizations",
    id: organizationId,
  })

  const {singleQuery: singleWallet} = useSingleGenericAPI<Wallet, WalletPatch>({
    baseURL: BASE_URL_ORGANIZATION,
    APIname: "wallets-orga-"+organizationId,
    id:  organizationId ? organizationId+"/wallet" : undefined,
  })

  

  return {
    organizationId,
    singleOrganizationQuery: singleQuery,
    deleteOrganizationQuery: deleteQuery,
    patchOrganizationQuery: patchQuery,
    singleWalletQuery: singleWallet,
  }
}

export default useSingleOrganization;
